import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import "./MedicalGrade.scss";
class MedicalGrade extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <div className="pj-box">
          <span className="text_24 bold-text">
            <FormattedMessage id="product.a5.medical-grade.a1" />
          </span>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <img src="/static/images/product/a5-xy.png" alt="none" />
            <div className="img-desc">
              <p className="bold-text">
                <FormattedMessage id="product.a5.medical-grade.a2" />
              </p>
              <p>
                <FormattedMessage id="product.a5.medical-grade.a3" />
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <img src="/static/images/product/a5-xya.png" alt="none" />
            <div className="img-desc">
              <p className="bold-text">
                <FormattedMessage id="product.a5.medical-grade.a4" />
              </p>
              <p>
                <FormattedMessage id="product.a5.medical-grade.a5" />
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MedicalGrade)
);
